import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid2,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SchoolIcon from "@mui/icons-material/School";
import PersonIcon from "@mui/icons-material/Person";
import FaceIcon from "@mui/icons-material/Face";
import { useNavigate } from "react-router-dom";

const RoleSelectionModal = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleRoleSelect = (role) => {
    onClose();
    if (role === "school") {
      navigate("/SchoolSignUp");
    } else if (role === "teacher") {
      navigate("/TeacherSignUp");
    } else if (role === "student") {
      navigate("/StudentSignUp");
    }
  };

  const roles = [
    {
      key: "school",
      label: "School",
      description: "Register as a school",
      icon: <SchoolIcon sx={{ fontSize: 24, color: "#185FA5" }} />,
    },
    {
      key: "teacher",
      label: "Pro Teacher",
      description: "Register as a Pro teacher",
      icon: <PersonIcon sx={{ fontSize: 24, color: "#185FA5" }} />,
    },
    {
      key: "student",
      label: "Student",
      description: "Register as a student",
      icon: <FaceIcon sx={{ fontSize: 24, color: "#185FA5" }} />,
    },
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
          padding: "8px",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "12px 16px 6px 16px",
        }}
      >
        <Typography
          sx={{ fontSize: "16px", fontWeight: 500, color: "text.primary" }}
        >
          Choose your role
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ padding: "0 16px 16px 16px" }}>
        <Typography
          sx={{ fontSize: "13px", color: "text.secondary", mb: 2 }}
        >
          Select how you want to sign up
        </Typography>

        <Grid2 container spacing={1.25}>
          {roles.map((role) => (
            <Grid2 key={role.key} size={{ xs: 12, sm: 4 }}>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => handleRoleSelect(role.key)}
                sx={{
                  height: "auto",
                  padding: "16px 8px",
                  borderRadius: "8px",
                  borderColor: "divider",
                  backgroundColor: "action.hover",
                  color: "text.primary",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "8px",
                  textTransform: "none",
                  "&:hover": {
                    borderColor: "#185FA5",
                    backgroundColor: "#E6F1FB",
                  },
                }}
              >
                {role.icon}
                <Typography
                  sx={{
                    fontSize: "13px",
                    fontWeight: 500,
                    color: "text.primary",
                    lineHeight: 1,
                  }}
                >
                  {role.label}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "11px",
                    color: "text.secondary",
                    textAlign: "center",
                    lineHeight: 1.4,
                  }}
                >
                  {role.description}
                </Typography>
              </Button>
            </Grid2>
          ))}
        </Grid2>
      </DialogContent>
    </Dialog>
  );
};

export default RoleSelectionModal;